(function () {
  'use strict';

  angular
    .module('settings.customization')
    .controller('CustomizationCtrl', CustomizationCtrl);

  CustomizationCtrl.$inject = ['Settings', '$stateParams', '$rootScope'];

  function CustomizationCtrl(Settings, $stateParams, $rootScope) {
    var vm = this;
  }
})();
